import { ChangeDetectionStrategy, Component, ElementRef, inject, Inject, Pipe, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SelectUsersInputComponent } from 'src/app/features/users/components/select-users-input/select-users-input.component';
import { UsersStore } from '../../users-store';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { User } from 'src/app/models/user.model';
import { GlobalStore } from 'src/app/store/global-store';
import { EmailBodyComponent } from '../email-body/email-body.component';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MailForm } from 'src/app/models/mailForm';
import { Reminder } from 'src/app/models/reminder';
import { QuestionnaireCategory } from 'src/app/models/questionnaireCategory.model';
import { toSignal, ToSignalOptions } from '@angular/core/rxjs-interop';
import { Recipients } from 'src/app/models/recipients.model';
import { DualCalendarRangePickerComponent, ICalendarResults } from "../../../../shared/components/dual-calendar-range-picker/dual-calendar-range-picker.component";
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { combineLatest, map } from 'rxjs';
import { ToggleComponent } from 'src/app/shared/components/toggle/toggle.component';
import { AutoResizeDirective } from 'src/app/directves/autoresize.directive';
import { HighlightAtWordsDirective } from 'src/app/directves/highlight-at-words.directive';
import { QueDatePipe } from 'src/app/pipes/date.pipe';
import { QueDateHourFormatAmPmPipe } from 'src/app/pipes/date-hour-format-am-pm.pipe';
// import { parseToLocalDate } from 'src/app/shared/utils/date.utils';

@Component({
    providers: [UsersStore],
    templateUrl: './choose-recipients.component.html',
    styleUrls: ['./choose-recipients.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, TranslateDirective, TranslatePipe, MatFormFieldModule, ReactiveFormsModule, OverlayModule, QueDateHourFormatAmPmPipe,
        MatSelectModule, MatDialogModule, MatInputModule, SelectUsersInputComponent, EmailBodyComponent, FormsModule, DualCalendarRangePickerComponent, AutoResizeDirective, HighlightAtWordsDirective, ToggleComponent, QueDatePipe]
})
export class ChooseRecipientsComponent {
  @ViewChild('reminderStartDate') reminderStartDate!: ElementRef;
  selectedRangeIsOpened = false;
  selectedReminderStartDateIsOpened = false;
  selectedReminderEndDateIsOpened = false;
  #userStore = inject(UsersStore);
  #builder = inject(FormBuilder);
  #globalStore = inject(GlobalStore)

  isRecipients$ = toSignal(this.#userStore.isRecipients$);
  recipients$ = this.#userStore.recipient$;
  frequency$ = toSignal(this.#globalStore.frequency$);
  hourers$ = this.#globalStore.houers$;
  choosenRecipient$ = toSignal(this.#userStore.choosenRecipient$);

  isCreated = false;
  reminderForm = this.#builder.group({
    content: new FormControl<string | undefined>(''),
    startDate: new FormControl<Date | null>(null, [Validators.required]),
    hour: new FormControl<number>(10),
    frequencyId: new FormControl<number | null>(null),
    endDate: new FormControl<Date | null>(null),
    isApproval: new FormControl<boolean>(false),
    subject: new FormControl<string>(''),
    body: new FormControl<string>(''),
  });
  subject = new FormControl("", [Validators.required]);
  body = new FormControl("", [Validators.required]);
  sendEmail = new FormControl<boolean>(false);
  submissionDate = new FormControl<Date | null>(null, [Validators.required]);
  step = 1;
  reminder?: Reminder;
  placeholder = '';
  name = '';
  category = { id: -1, name: "", enName: "" } as QuestionnaireCategory;
  users: User[] = [];
  frequencyChoosen$ = toSignal(combineLatest(
    this.reminderForm.controls.frequencyId.valueChanges, this.#globalStore.frequency$)
    .pipe(map(([id, frequencyArr]) => frequencyArr.find(x => x.id == id)))
  );

  isUnauthorized = false;
  isReminder = false;
  isAddRecipients = false;
  isOpenReminder = false;
  selectedHourIsOpened = false;
  selectedRepetIsOpened = false;
  isSendAll = new FormControl<boolean>(false);

  readonly positonAreaForSelectedDate = [{
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'center',
  }] as ConnectedPosition[];
  readonly positonAreaForSelected = [{
    originX: 'end',
    originY: 'center',
    overlayX: 'end',
    overlayY: 'center',
  }] as ConnectedPosition[];

  constructor(@Inject(MAT_DIALOG_DATA) private readonly data: { name: string; placeholder: string; id: number; category: QuestionnaireCategory, recipients: Recipients, mailForm: MailForm, isReminder: boolean, isAddRecipients?: boolean, editReminder?: Reminder, isCreated?: boolean, isUnauthorized: boolean, isSendAll: boolean }, private readonly dialogRef: MatDialogRef<ChooseRecipientsComponent>) {
    this.reminderForm.controls.frequencyId.valueChanges.subscribe(
      frequencyId => {
        if (frequencyId === 1) {
          this.reminderForm.controls.endDate.setValue(null);
        }
      }
    )
    if (data.recipients) {
      this.#userStore.updateRecipients(data.recipients)
    }
    if (data.isCreated) {
      this.isCreated = true;
    }
    dialogRef.disableClose = true;
    this.placeholder = data.placeholder;
    this.name = data.name;
    this.subject.setValue(data.name);
    if (data.category) {
      this.category = data.category;
    }
    this.isUnauthorized = data.isUnauthorized;
    this.isReminder = data.isReminder;
    this.isAddRecipients = data.isAddRecipients ?? false;
    this.isSendAll.setValue(data.isSendAll);
    this.reminder = data.editReminder;
    if (data.isReminder) {
      if (data.editReminder) {
        if (data.editReminder.recipients?.users != undefined) {
        }
        this.subject.setValue(data.editReminder.subject ?? "");
        this.body.setValue(data.editReminder.content ?? "");
        this.reminderForm.controls.startDate.setValue(data.editReminder.startDate);
        if (data.editReminder.endDate) {
          this.reminderForm.controls.endDate.setValue(data.editReminder.endDate);
        }
        if (data.editReminder.frequencyId) {
          this.reminderForm.controls.frequencyId.setValue(data.editReminder.frequencyId);
        }
        if (data.editReminder.hour) {
          this.reminderForm.controls.hour.setValue(data.editReminder.hour);
        }
        this.reminderForm.controls.isApproval.setValue(data.editReminder.isApproval ?? false);
        // this.reminderForm.controls.hourId.setValue(data.editReminder);
      }
    }
    else {
      if (data.mailForm.subject)
        this.subject.setValue(data.mailForm.subject);
      const defaultMessage = this.#globalStore.isHeSignal$()
        ? "שלום @firstName @lastName ,\nשאלון חדש \"@questionnaireName\" נשלח וממתין לתשובתך בפלטפורמת Boardirector \nנא להשלים ולשלוח את תשובותיך עד לתאריך @dueDate.\n@questionnaireLink \n תודה על שיתוף הפעולה,"
        : "Dear @firstName @lastName ,\nA new questionnaire \"@questionnaireName\" has been submitted and requires your attention in the Boardirector platform.\nKindly complete and submit your answers by @dueDate.\n@questionnaireLink \n Thank you for your cooperation,\nAmdocs Legal, Relationships Defined";
      if (data.mailForm.body && data.mailForm.body != "") {
        this.body.setValue(data.mailForm.body);
      } else {
        this.body.setValue(defaultMessage);
      }
      if (data.mailForm.submissionDateNTZ) {
        this.submissionDate.setValue( data.mailForm.submissionDateNTZ ?? null);
      }
      if (data.editReminder) {
        this.isOpenReminder = true;
        this.reminderForm.patchValue({ ...data.editReminder })
      }
    }
  }

  publish(event: string) {
    let startdateTime: Date | null = null;
    let enddateTime: Date | null = null;
    if (this.reminderForm.controls.startDate.value && (this.isOpenReminder || this.isReminder)) {
      // Copy the sta rtDate and set the hour
      startdateTime = new Date(this.reminderForm.controls.startDate.value);
      startdateTime.setHours(this.reminderForm.controls.hour.value ?? 0, 0, 0, 0); // Set hour, minutes, seconds, and milliseconds
    }

    if (this.reminderForm.controls.endDate.value && (this.isOpenReminder || this.isReminder)) {
      // Copy the startDate and set the hour
      enddateTime = new Date(this.reminderForm.controls.endDate.value);
      enddateTime.setHours(this.reminderForm.controls.hour.value ?? 0, 0, 0, 0); // Set hour, minutes, seconds, and milliseconds
    }
    this.dialogRef.close([this.choosenRecipient$(),
    this.isOpenReminder || this.isReminder ?
      { ...this.reminderForm.value, id: this.reminder?.id, startDate: startdateTime, endDate: enddateTime } as Reminder : null,
    { subject: this.subject.value, body: this.body.value, submissionDateNTZ: this.submissionDate.value, sendEmail: this.sendEmail.value },
      event,
      this.isSendAll.value]);
  }
  addReminder() {
    this.isOpenReminder = true;
  }
  changeSelectedRangeIsOpened() {
    this.selectedRangeIsOpened = true
  }
  openChooseReminderDate() {
    const triggerRect = this.reminderStartDate?.nativeElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    // Check if the menu would open out of the viewport
    if (triggerRect.bottom + 150 > viewportHeight) { // assuming 200px height for the menu
      this.positonAreaForSelectedDate[0].overlayY = 'bottom';
    } else {
      this.positonAreaForSelectedDate[0].overlayY = 'center';
    }
    this.selectedReminderStartDateIsOpened = true;
  }
  openChooseReminderEndDate() {
    this.selectedReminderEndDateIsOpened = true;
  }
  removeReminder() {
    this.isOpenReminder = false;
    this.reminderForm.patchValue({ content: null, startDate: null, hour: 10, frequencyId: null, endDate: null, isApproval: null });
  }
  chooseHour(id: number) {
    this.reminderForm.controls.hour.setValue(id);
    this.selectedHourIsOpened = false;
  }
  chooseRepete(id: number) {
    this.reminderForm.controls.frequencyId.setValue(id);
    this.selectedRepetIsOpened = false;
  }
  next() {
    if (this.isReminder) {
      this.publish(this.data.editReminder ? "update" : "create");
    }
    if (this.isAddRecipients) {
      this.publish('publish');
    }
    else {
      if (this.isRecipients$() || this.isSendAll.value) {
        this.step = 2;
      }
    }
  }
  back() {
    this.step = 1;
  }
  save() {
    this.publish('save');
  }
  appproval() {
    this.reminderForm.controls.isApproval.setValue(!this.reminderForm.controls.isApproval.value)
  }

  cancel() {
    //close with save:
    // this.dialogRef.close([this.choosenRecipient$(), this.isOpenReminder || this.isReminder ? { ...this.reminderForm.value, id: this.reminder?.id } as Reminder : null, { subject: this.subject.value, body: this.body.value, submissionDate: this.submissionDate.value }, "close"]);
    this.dialogRef.close();
  }
  reminderValidator(): boolean {
    return this.reminderForm.controls.startDate.valid;
  }

  startDateRangePicked(date: ICalendarResults, isReminderDate: boolean = false) {
    if (date.startDate) {
      if (isReminderDate) {
        this.reminderForm.controls.startDate.setValue(date.startDate);
        if (!(this.reminderForm.controls.frequencyId.value &&
          this.reminderForm.controls.frequencyId.value != 1)) {
          this.selectedReminderStartDateIsOpened = false;
        }
      }
      else {
        this.submissionDate.setValue(date.startDate);
        this.selectedRangeIsOpened = false;
      }
    }
    if (date.endDate) {
      if (isReminderDate) {
        this.reminderForm.controls.endDate.setValue(date.endDate);
        this.selectedReminderStartDateIsOpened = false;
      }
    }
  }

  endDateRangePicked(date: ICalendarResults) {
    if (date.startDate) {
      this.reminderForm.controls.endDate.setValue(date.startDate);
    }
    this.selectedReminderEndDateIsOpened = false;
  }
  changeSendEmail() {
    this.sendEmail.setValue(!this.sendEmail.value)
  }
  changeSendAll() {
    this.isSendAll.setValue(!this.isSendAll.value)
    if(this.isAddRecipients){
      this.#userStore.RemoveAllNewRecipientsAndGroups();
    }
    if(!this.isAddRecipients)
      this.#userStore.RemoveAllRecipientsAndGroups();
  }
}
